import React, { useState } from 'react';
import { CustomModal, useCustomToast } from '../../../../components';
import { Item, RefundsRequest } from '../../types/refunds-response';
import { useAtom } from 'jotai';
import { useCreateRefund } from '../../../../hooks';
import {
  useAssets,
  useDependeciesByUser,
  useRefundStates,
  useGetUtilsKeys,
} from '../../../../share';
import { authAtom } from '../../../../state';
import { UploadedFile } from '../../../../utils';
import RefundCreateView from '../Views/RefundsCreateView';
import useRefundRequestFormik from '../../../../utils/validators/refund-request/refund-request-validator';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';
import ModalAdditions from '../components/ModalAdditions';

interface RefundsCreateProps {
  isOpen: boolean;
  OnClose: () => void;
  modalState?: any;
  refetch?: any
}

const RefundsCreateContainer: React.FC<RefundsCreateProps> = ({
  isOpen,
  OnClose,
  modalState,
  refetch
}) => {
  const [files, setFiles] = React.useState<UploadedFile[]>([]);
  const [isOpenSaveChanges, setiIsOpenSaveChanges] = useState(false);

  const [selectedRowKeys, setSelectedRowKeys] = React.useState<React.Key[]>([]);
  const { showToast } = useCustomToast();
  const [isModalAdditions, setIsModalAdditions] = useState<boolean>(false);

  const [authData] = useAtom(authAtom);
  const { mutateAsync, isPending: loadCreate } = useCreateRefund();
  const { data: refundStates } = useRefundStates();

  const { data: dependenciesById } = useDependeciesByUser(authData?.user.id);

  const { data: assetList } = useAssets({ responsible_id: authData?.user.id, role_service: '1', asset_status_id: '1' });

 const { data: locations = [] } = useGetUtilsKeys(
    'keys[]=locations&filter[branch_id]='+authData?.user?.branch_id,
  );

  const { data: utilKeys = [] } = useGetUtilsKeys(
    'keys[]=providers&keys[]=dependencies&keys[]=asset_type',
  );

  const [additionSelected, setAdditionSelected] = useState({});

  const handlePayload = (values: any) => {
    if (values.refounds_type?.toString() === '1') {
      return selectedRowKeys?.map((value) => ({ asset_id: value }) as Item);
    } else {
      return selectedRowKeys?.map((value) => ({ good_id: value }) as Item);
    }
  };
  const closeModalSaveChanges = () => {
    setiIsOpenSaveChanges(false);
  };
  const openModalSaveChanges = () => {
    setiIsOpenSaveChanges(true);
  };
  const onReset = () => {
    closeModalSaveChanges();

    formik.resetForm();
    setFiles([]);
    setSelectedRowKeys([]);
    setTimeout(() => {
      OnClose();
    }, 0);
  };
  const onSave = async (values: Partial<RefundsRequest>) => {
    try {
      const payload: Partial<RefundsRequest> = {
        requester_id: authData?.user.id.toString(),
        dependency_id: values.dependency_id,
        location_id: values.location_id,
        justification: values.justification,
        documents: files,
        items: handlePayload(values),
        signature_url: '',
        request_type_id: values.refounds_type?.toString(),
        observations: values.observations,
      };

      await mutateAsync({
        ...(payload as RefundsRequest),
      });
      refetch()
    } catch (error) {
      showToast('error', 'Error al crear l solicitud');
    }
  };

  const formik = useRefundRequestFormik({ onSubmit: onSave });

  const handleSubmitValidate = () => {

    if (!selectedRowKeys.length) {
      showToast('error', 'Debes seleccionar items');
      return;
    }

    if (formik.isValid) {
      openModalSaveChanges();
    }
  };

  const handleSaveAddition = (data: any) => {
    setAdditionSelected(data);
    handleModalAdditions(true);
  };

  const handleModalAdditions = (opc: boolean) => {
    setIsModalAdditions(opc);
  };
  const confirmSaveChanges = async () => {
    try {
      await onSave(formik.values); 

      onReset(); 
    } catch (error) {
      showToast('error', 'Error al guardar');
    }
  };
  return (
    <CustomModal
      title={`Nueva solicitud de reintegro`}
      labelSubmit="Guardar solicitud"
      open={isOpen}
      onCancel={() => {
        onReset();
      }}
      width="95vw"
      isLoadingSave={loadCreate}
      onSave={() => handleSubmitValidate()}
    >
      <RefundCreateView
        itemTypes={utilKeys?.asset_type || []}
        refundStates={refundStates}
        authData={authData}
        formik={formik}
        onCancel={onReset}
        onFiles={setFiles}
        files={files}
        assetsActivos={assetList}
        location={locations?.locations || []}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        handleSaveAddition={handleSaveAddition}
        dependenciesById={dependenciesById}
        modalState={modalState}
      />

      <ModalSaveChanges
        title="Guardar cambios"
        textOne="¿Está seguro de crear esta solicitud de reintegro?"
        textTwo="Una vez creado no podrá realizar cambios."
        open={isOpenSaveChanges}
        width={900}
        isLoadingSave={true}
        onClose={() => {
          closeModalSaveChanges();
        }}
        labelSubmit="Aceptar"
        onSave={() => confirmSaveChanges()}
      />
      <ModalAdditions
        onSave={() => alert('a')}
        isShow={isModalAdditions}
        handleModalAdditions={handleModalAdditions}
        formik={formik}
        additionSelected={additionSelected}
      />
    </CustomModal>
  );
};

export default RefundsCreateContainer;
